import { Link, useLocation } from "react-router-dom";
import { linkArray, QA_ROLES,QA_DASHBOARD_ROLES ,ADMIN_ROLES} from "../constant";
import Navlink from "../common/FormInputs/Navlink";
import { useSelector } from "react-redux";
import { logOut } from "../services/api";
import useExpiredToken from "../utils/useExpiredToken";
import { useToast } from "../utils/Toast";
import { useState } from "react";
import DeleteModal from "./models/DeleteModal";
import { useLoader } from "../contexts/LoaderContext";

const Sidebar = () => {
  const { pathname } = useLocation();
  const role = useSelector((state) => state.auth.role);
  const token = useSelector((state) => state.auth.jwtToken);
  const expireToken = useExpiredToken();
  const toast = useToast();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const { showLoader, hideLoader } = useLoader();

  const handleLogout = async () => {
    showLoader();
    const res = await logOut("auth/logout", token, {});
    if (res) {
      toast.success(res.data);
      setTimeout(() => {
        expireToken();
      }, 300);
    }
    hideLoader();
  };

  const topLinks = linkArray.slice(0, 7).filter((item) => {
  if (QA_DASHBOARD_ROLES.includes(role)) {
    // Hide these tabs for dashboard QA roles
    return item.title !== "Dashboard"  &&
           item.title !== "Assigned calls" &&
           item.title !== "Audited calls" &&
           item.title !== "Completed calls" &&
           item.title !== "Assign calls" &&
           (item.title !== "Manage users" || role=== "qualityassurance" || role === "qualitylead" || role === "traininglead" || role === "trainer" )&&
          //  (item.title !== "Manage Trainers" || role === "traininglead" && role !== "superAdmin") &&
          //  (item.title !== "Manage Trainee" || role === "traininglead" || role === "trainer") &&
           (item.title !== "PKT Questionnaire" || role === "traininglead");
  }
  
  if (QA_ROLES.includes(role)) {
    // Hide these tabs for other QA roles
    return item.title !== "Assign calls" &&
          !(role === "qualityassurance" && item.title === "Assigned calls") &&
           (item.title !== "Manage users"|| role=== "qualitylead" || role === "qualityassurance" ) &&
          //  (item.title !== "Manage Trainers" || role === "traininglead") &&
          //  (item.title !== "Manage Trainee" || role === "traininglead" || role === "trainer") &&
           (item.title !== "PKT Questionnaire" || role === "traininglead");
  }
  if(ADMIN_ROLES.includes(role)){
     // Hide these tabs for other Admin roles
       return item.title !== "Manage Trainers" && 
       item.title !== "Manage Trainee" &&
       item.title !== "PKT Questionnaire";
  }
  return true; // Admins etc.
});


  const bottomLinks = linkArray.slice(7);

  return (
    <>
      <nav id="sidebar">
        <div className="logo">
          <Link to="/">
            <img src="/assets/logo.png" alt="Logo" width={150} />
          </Link>
        </div>
        <div className="innerset">
          <div>
            <nav className="nav">
              {topLinks &&
                topLinks?.map((item, i) => (
                  <Navlink
                    key={i}
                    pathname={pathname}
                    item={item}
                    role={role}
                    handleLogout={handleLogout}
                  />
                ))}
            </nav>
          </div>
          <div className="bottom-links">
            {bottomLinks &&
              bottomLinks?.map((item, i) => (
                <Navlink
                  key={i}
                  pathname={pathname}
                  item={item}
                  role={role}
                  handleLogout={() => setShowLogoutConfirm(true)}
                />
              ))}
          </div>
        </div>
      </nav>
      <DeleteModal
        open={showLogoutConfirm}
        handleCancel={() => setShowLogoutConfirm(false)}
        handleDelete={handleLogout}
        title={"Log out?"}
        description={
          "You’ll be signed out of your admin panel. Don’t worry — all your work is saved."
        }
        confirmButtonText={"Log out"}
      />
    </>
  );
};

export default Sidebar;
